/* @flow */

import React from 'react';

const replaceDotBySlash = (template: EditorialBlockTemplate) =>
  template.replace('.', '/');

const usingPlugin = (template: EditorialBlockTemplate) => (
  execute: Object => void,
  defaultValue: Object = null
) => {
  try {
    const plugin = require(`./plugins/${replaceDotBySlash(template)}/index.js`);
    return execute(plugin);
  } catch (error) {
    console.warn(`No plugin found for template ${template}`, error);
    return defaultValue;
  }
};

export const getEditComponent = (block: EditorialBlock) => {
  return usingPlugin(block.template)(plugin => {
    const component = plugin.getEditComponent();
    return React.createElement(component, {
      block,
    });
  });
};

export const getViewComponent = (block: EditorialBlock) => {
  return usingPlugin(block.template)(plugin => {
    const component = plugin.getViewComponent();
    return React.createElement(component, {
      block,
    });
  });
};

export const getRenderComponent = (block: EditorialBlock) => {
  return usingPlugin(block.template)(plugin => {
    const component = plugin.getRenderComponent();
    return React.createElement(component, {
      block,
    });
  });
};



// WEBPACK FOOTER //
// ./src/modules/edito/plugin.js